import React from 'react';
import { useNavigate } from 'react-router-dom';

import { Page } from '@occc-app/design-system';
import { Typography, Button, Card, CardHeader, CardContent } from '@occc/ui-design-system';

import CreateSegmentFormContainer from './SegmentCreateFormContainer';

const PAGE_TITLE = 'Create Segment';

interface SegmentCreateProps {
  submitCreateSegmentForm: () => void;
}

const SegmentCreate: React.FC<SegmentCreateProps> = ({ submitCreateSegmentForm }) => {
  const navigate = useNavigate();

  const actions: React.ReactNode[] = [
    <Button
      key='Cancel'
      variant='outlined'
      role='button'
      color='secondary'
      onClick={() => navigate(-1)}
    >
      Cancel
    </Button>,
    <Button key='Create' variant='contained' color='secondary' onClick={submitCreateSegmentForm}>
      Create
    </Button>,
  ];

  return (
    <Page
      browserTabTitle={PAGE_TITLE}
      actions={actions}
      pageHeaderProps={{ title: PAGE_TITLE }}
      containerProps={{ variant: 'md' }}
    >
      <Card>
        <CardHeader
          title={
            <Typography variant='h6' component='h3'>
              General Details
            </Typography>
          }
        />
        <CardContent>
          <CreateSegmentFormContainer />
        </CardContent>
      </Card>
    </Page>
  );
};

export default SegmentCreate;
